// @flow
import type { Action, Address } from '../actions/types';
import {
	FETCH_DELIVERY_ADD,
	FETCH_DELIVERY_ADD_SUCCESS,
	FETCH_DELIVERY_ADD_ERROR,
	SAVE_DELIVERY_ADD,
	SAVE_DELIVERY_ADD_SUCCESS,
	SAVE_DELIVERY_ADD_ERROR,
	SET_DELIVERY_ADD,
} from '../actions/types';

type DeliveryState = {|
	address: any,
	fetching: boolean,
	saving: boolean,
	error: null | Error,
	selectedAddress: Address | null,
|};

const initialState: DeliveryState = {
	address: null,
	fetching: false,
	saving: false,
	error: null,
	selectedAddress: null,
};

export const deliveryReducer = (state: DeliveryState = initialState, action: Action): DeliveryState => {
	const { type, payload } = action;
	switch (type) {
		case FETCH_DELIVERY_ADD:
			return {
				...state,
				fetching: true,
				error: null,
			};

		case FETCH_DELIVERY_ADD_SUCCESS:
			return {
				...state,
				address: payload,
				error: null,
				fetching: false,
			};

		case FETCH_DELIVERY_ADD_ERROR:
			return {
				...state,
				address: [],
				error: payload,
				fetching: false,
			};

		case SAVE_DELIVERY_ADD:
			return {
				...state,
				saving: true,
				error: null,
			};

		case SAVE_DELIVERY_ADD_SUCCESS:
			return {
				...state,
				error: null,
				saving: false,
				address: payload,
			};

		case SAVE_DELIVERY_ADD_ERROR:
			return {
				...state,
				error: payload,
				saving: false,
			};

		case SET_DELIVERY_ADD:
			return {
				...state,
				selectedAddress: payload,
			};

		default:
			return state;
	}
};
